// extracted by mini-css-extract-plugin
export var hint = "partnersHeader-module--hint--6HJ3B";